export const BASE_URL = '/login';
export const BASE_TITLE = '';

export const CONFIG = {
  layout: 'vertical',
  collapseMenu: false,
  layoutType: 'menu-dark'
};
